import React from 'react';
import { ValueContainerProps, SingleValueProps, PlaceholderProps, components } from 'react-select';

import { Option } from '../SelectDropdown.types';
import styled from 'styled-components';

// Styled component for the multi-value container
const StyledMultiValue = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: calc(100% - 1px);
`;

export const CustomValueContainer = (props: ValueContainerProps<Option>) => {
  const { hasValue, isMulti, selectProps, children } = props;

  return (
    <components.ValueContainer {...props}>
      {hasValue ? (
        isMulti ? (
          <StyledMultiValue>
            {selectProps.value &&
              Array.isArray(selectProps.value) &&
              selectProps.value.map((item: Option, index) => (
                <React.Fragment key={item.value}>
                  {index > 0 && ', '}
                  {item.label}
                </React.Fragment>
              ))}
          </StyledMultiValue>
        ) : (
          selectProps.value && (
            <components.SingleValue
              {...(props as SingleValueProps<Option, boolean>)}
              data={selectProps.value as Option}
            >
              {(selectProps.value as Option).label}
            </components.SingleValue>
          )
        )
      ) : (
        <components.Placeholder
          {...(props as PlaceholderProps<Option, boolean>)}
          isFocused={selectProps.menuIsOpen || false}
        >
          {selectProps.placeholder}
        </components.Placeholder>
      )}
      {
        // Render any remaining children (e.g., the input field)
        children && Array.isArray(children) && children[children.length - 1]
      }
    </components.ValueContainer>
  );
};
